import { gsap } from "gsap";
import { initScrollWorld } from "./scroll-world";

/** Retain the business offer; the independent game owns the next full-width scene. */
export function initHeroStudio({ reduceMotion }) {
  const hero = document.querySelector("[data-hero-studio]");
  const intro = gsap.timeline({ defaults: { ease: "power3.out" } });
  if (hero && !reduceMotion) {
    intro.from(hero.querySelector("h1"), { autoAlpha: 0, y: 24, duration: 0.7 })
      .from(hero.querySelector(".hero__copy p"), { autoAlpha: 0, y: 14, duration: 0.55 }, 0.18)
      .from(hero.querySelectorAll(".hero__actions .button"), { autoAlpha: 0, y: 12, duration: 0.45, stagger: 0.1 }, 0.32);
  }
  const cleanup = initScrollWorld({ reduceMotion });
  return () => { intro.kill(); cleanup(); };
}
